import { render, staticRenderFns } from "./categoryDia.vue?vue&type=template&id=ca84a78a&scoped=true"
import script from "./categoryDia.vue?vue&type=script&lang=js"
export * from "./categoryDia.vue?vue&type=script&lang=js"
import style0 from "./categoryDia.vue?vue&type=style&index=0&id=ca84a78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca84a78a",
  null
  
)

export default component.exports